import { useEffect, useState } from 'react';
import './ReadingQuest.css';
import library from '../../../assets/json/library.json';
import CoCSpeechBubble from '../../utils/cocSpeechBubble/CoCSpeechBubble';
import {
  getDocument,
  updateDocument,
} from '../../../firebase-functions/database';
import { toast } from 'react-toastify';
import { auth } from '../../../firebase-functions/config';
import { QuestReadingRoom } from './QuestReadingRoom';

const BookShelf = ({ bucket, bucketIndex, onSelectBook }) => {
  return (
    <div className='quest-book-shelf'>
      {bucket.map((book, index) => (
        <div
          className={'book pop-in quest-book-' + book.orientation}
          key={index}
          style={{ animationDelay: `${index * 0.15}s` }}>
          <img
            src={
              'https://mi.content.readinga-z.com/raz_book_image/' +
              book?.id +
              '/projectable/small/1/book/page-0.jpg'
            }
            onClick={() => {
              onSelectBook(book, bucketIndex - 1);
            }}
            alt={book.title}
            className='quest-book-cover'
          />
        </div>
      ))}
    </div>
  );
};

const SelectedBooks = ({ selectedBooks, length }) => {
  return (
    <div className='selected-books-container'>
      {Array.from({ length: length }, (_, i) => i + 1).map((num) =>
        selectedBooks[num - 1] ? (
          <div key={num} className='selected-book'>
            <img
              src={
                'https://mi.content.readinga-z.com/raz_book_image/' +
                selectedBooks[num - 1]?.id +
                '/projectable/small/1/book/page-0.jpg'
              }
              alt={selectedBooks[num - 1]?.title}
              className='quest-selected-book-cover'
            />
          </div>
        ) : (
          <div key={num} className='selected-book empty-book-slot'>
            <span>+</span>
          </div>
        ),
      )}
    </div>
  );
};

const GreetingWarden = ({ messageIndex, setMessageIndex, handleSubmit }) => {
  const messages = [
    'Greetings, young warrior!..',
    'The path to wisdom begins here...',
    'Are you ready for a challenge?',
    "Let's Go!",
    'Pick one of the books from 5',
    'Great choice!',
    'Now, Pick another book',
    'I like that!',
    'One last book, please',
    'Awesome Taste!',
    'Last Last book. I promise!',
    'All Set! Your quest begins now!',
    'Are you ready?',
  ];

  const messaegImgURLs = [
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_02_Shadow.png?alt=media&token=0bdea98a-0102-433d-a1d2-8734428fa23e',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_01_Shadow.png?alt=media&token=2a9128ab-0b7e-4e81-819e-4a774b485aeb',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_02_Shadow.png?alt=media&token=0bdea98a-0102-433d-a1d2-8734428fa23e',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_03_Shadow.png?alt=media&token=e30cf965-6161-4023-be20-0d9868055084',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_01_Shadow.png?alt=media&token=2a9128ab-0b7e-4e81-819e-4a774b485aeb',
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FGW_Clasharama_01_Shadow.png?alt=media&token=2a9128ab-0b7e-4e81-819e-4a774b485aeb',
  ];
  // const [messageIndex, setMessageIndex] = useState(1);

  useEffect(() => {
    // play sound effect on component mount
    //
    let audio;

    if (messageIndex === 0) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazydavelong3.mp3?alt=media&token=0670651b-bfe6-4571-b434-5e34ad737423',
      );
      setTimeout(() => {
        audio.play();
      }, 700);
    } else if (messageIndex === 1) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-3.mp3?alt=media&token=56ae98af-b2a1-4ad2-ae37-8025027dd8f2',
      );
      setTimeout(() => {
        audio.play();
      }, 700);
    } else if (messageIndex === 2) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazydavelong2_Li2f1r7.mp3?alt=media&token=63978326-5f72-44b1-87de-6b296524b77f',
      );
      setTimeout(() => {
        audio.play();
      }, 700);
    } else if (messageIndex === 3) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-6.mp3?alt=media&token=16809839-39d6-43ba-99f9-a8e7d597405a',
      );
      setTimeout(() => {
        audio.play();
      }, 200);
      setTimeout(() => {
        setMessageIndex(4); // Reset to the first message after the last one
      }, 3500); // Wait for 2 seconds before resetting
    } else if (messageIndex === 4) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-3.mp3?alt=media&token=56ae98af-b2a1-4ad2-ae37-8025027dd8f2',
      );
      setTimeout(() => {
        audio.play();
      }, 1500);
    } else if (messageIndex === 5) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-3.mp3?alt=media&token=56ae98af-b2a1-4ad2-ae37-8025027dd8f2',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
      setTimeout(() => {
        setMessageIndex(6);
      }, 3500);
    } else if (messageIndex === 6) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazydavelong2_Li2f1r7.mp3?alt=media&token=63978326-5f72-44b1-87de-6b296524b77f',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
    } else if (messageIndex === 7) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-6.mp3?alt=media&token=16809839-39d6-43ba-99f9-a8e7d597405a',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
      setTimeout(() => {
        setMessageIndex(8);
      }, 3500);
    } else if (messageIndex === 8) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazydavelong2_Li2f1r7.mp3?alt=media&token=63978326-5f72-44b1-87de-6b296524b77f',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
    } else if (messageIndex === 9) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-6.mp3?alt=media&token=16809839-39d6-43ba-99f9-a8e7d597405a',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
      setTimeout(() => {
        setMessageIndex(10);
      }, 3500);
    } else if (messageIndex === 10) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazydavelong2_Li2f1r7.mp3?alt=media&token=63978326-5f72-44b1-87de-6b296524b77f',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
    } else if (messageIndex === 11) {
      audio = new Audio(
        'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fcrazy-dave%2Fcrazy-dave-line-6.mp3?alt=media&token=16809839-39d6-43ba-99f9-a8e7d597405a',
      );
      setTimeout(() => {
        audio.play();
      }, 500);
      setTimeout(() => {
        setMessageIndex(12);
      }, 3500);
    }
  }, [messageIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => {
        if ([2, 4, 6, 8, 10].includes(prevIndex)) {
          clearInterval(interval);
          return prevIndex;
        }
        if (prevIndex === null) {
          return 0;
        } else if (prevIndex < messages.length - 1) {
          return prevIndex + 1;
        } else {
          clearInterval(interval);
          return prevIndex;
        }
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='grand-warden-container'>
      {messageIndex !== null && (
        <>
          <CoCSpeechBubble
            tailDirection='right'
            key={'grand-warden-speech-' + messageIndex}>
            {messages[messageIndex]}
            {messageIndex === 2 && (
              <button
                className='coc-warden-speect-btn'
                onClick={() => {
                  setMessageIndex(3);
                }}>
                Yes
              </button>
            )}
            {messageIndex === 12 && (
              <button className='coc-warden-speect-btn' onClick={handleSubmit}>
                Let's Go!
              </button>
            )}
          </CoCSpeechBubble>
          <img
            src={messaegImgURLs[messageIndex]}
            alt=''
            className='grand-warden-img'
            key={'grand-warden-img-' + messageIndex}
          />
        </>
      )}
    </div>
  );
};

export const ReadingQuest = ({ readerId }) => {
  const [buckets, setBuckets] = useState([]);
  const [readerProfile, setReaderProfile] = useState(null);
  const [messageIndex, setMessageIndex] = useState(null);
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [state, setState] = useState(null);
  const [bookList, setBookList] = useState([]);
  const [maxStreaks, setMaxStreaks] = useState();
  const [streaks, setStreaks] = useState();
  const [toggleSkip, setSkip] = useState(false);
  const [wordTarget, setWordTarget] = useState(100);

  const getTarget = (performance, personalTarget) => {
    let readingDaysObject = {};
    let readingDaysEverydayObject = {};
    performance.map((entrance) => {
      const dateRead = new Date(entrance.dateRead.toDate());
      const today = new Date();
      const textDate =
        dateRead.getFullYear() +
        '-' +
        (dateRead.getMonth() + 1) +
        '-' +
        dateRead.getDate();
      const textToday =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();

      const bookInfo = library.find((bk) => entrance.book.bookId === bk.id);

      if (dateRead.getDay() === today.getDay() && dateRead !== textToday) {
        // if(dateRead.getDay() === 5 && textDate !== textToday){

        if (readingDaysObject[textDate]) {
          readingDaysObject[textDate] =
            readingDaysObject[textDate] + bookInfo.wordLength;
        } else {
          readingDaysObject[textDate] = bookInfo.wordLength;
        }
      } else if (dateRead !== textToday) {
        if (readingDaysEverydayObject[textDate]) {
          readingDaysEverydayObject[textDate] =
            readingDaysEverydayObject[textDate] + bookInfo.wordLength;
        } else {
          readingDaysEverydayObject[textDate] = bookInfo.wordLength;
        }
      }
    });
    let lastFourDays = [];

    if (Object.values(readingDaysObject).length === 0) {
      lastFourDays = [100];
    }
    if (Object.values(readingDaysObject).length >= 4) {
      lastFourDays = Object.values(readingDaysObject).slice(
        Object.values(readingDaysObject).length - 4,
        Object.values(readingDaysObject).length,
      );
    } else {
      lastFourDays = Object.values(readingDaysObject);
    }
    const maxNumber = Object.values(readingDaysObject).reduce(
      (max, current) => Math.max(max, current),
      100,
    );
    lastFourDays.push(maxNumber);
    const totalAverage =
      Object.values(readingDaysEverydayObject).reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      ) / Object.values(readingDaysEverydayObject).length || 100;
    lastFourDays.push(totalAverage);

    const sum = lastFourDays.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0,
    );

    const dailyAverage = sum / lastFourDays.length || 60;

    let newTarget = Math.floor(dailyAverage + dailyAverage / 4);

    if (newTarget > personalTarget) {
      newTarget = personalTarget;
    }

    return newTarget;
  };

  const getLexile = (performance) => {
    let last100Reads = performance.slice(-100);

    let averageLexile = 0;
    let sumLexile = 0;
    last100Reads.forEach((read) => {
      const book = library.find((bk) => bk.id === read.book.bookId);

      sumLexile += book ? book.lexile : 0;
    });
    averageLexile = sumLexile / last100Reads.length || 0;

    return Math.floor(averageLexile);
  };

  const getOrientation = (performance) => {
    let orintations = {};

    performance.forEach((entrance) => {
      const bookInfo = library.find((bk) => entrance.book.bookId === bk.id);
      if (bookInfo && bookInfo.orientation) {
        if (orintations[bookInfo.orientation]) {
          orintations[bookInfo.orientation] += 1;
        } else {
          orintations[bookInfo.orientation] = 1;
        }
      }
    });

    let maxOrientation = null;
    let maxCount = 0;
    for (const [orientation, count] of Object.entries(orintations)) {
      if (count > maxCount) {
        maxCount = count;
        maxOrientation = orientation;
      }
    }

    return maxOrientation;
  };

  const getPopularGenres = (performance) => {
    let genresCount = {};

    performance.slice(0, 100).forEach((entrance) => {
      const bookInfo = library.find((bk) => entrance.book.bookId === bk.id);
      if (bookInfo && bookInfo.tags) {
        bookInfo.tags.forEach((tag) => {
          if (tag === 'fiction' || tag === 'nonfiction') {
            return;
          }
          if (genresCount[tag]) {
            genresCount[tag] += 1;
          } else {
            genresCount[tag] = 1;
          }
        });
      }
    });

    let sortedGenres = Object.entries(genresCount).sort((a, b) => b[1] - a[1]);

    let popularGenres = sortedGenres.slice(0, 5).map((genre) => genre[0]);
    //

    return popularGenres;
  };

  const booksToAvoidFromThePast100Days = (performance) => {
    const booksToAvoid = new Set();

    performance.map((entrance) => {
      const dateRead = new Date(entrance.dateRead.toDate());
      const today = new Date();

      const timeDiff = today.getTime() - dateRead.getTime();
      const dayDiff = timeDiff / (1000 * 3600 * 24);

      if (dayDiff <= 100) {
        booksToAvoid.add(entrance.book.bookId);
      }
    });

    return booksToAvoid;
  };

  const getBooksMatchingLexile = (lexile) => {
    const matchingBooks = library.filter(
      (book) => book.lexile >= lexile - 100 && book.lexile <= lexile + 100,
    );

    return matchingBooks;
  };

  const giveBucketsByDistribution = (
    recommendedBooks,
    performance = [],
    lib = [],
  ) => {
    const MIN_BUCKET_SIZE = 5;

    // -------------------------------------------------------------------
    // Safety Checks — prevent runtime crashes
    // -------------------------------------------------------------------
    if (!Array.isArray(recommendedBooks)) {
      console.error('❌ recommendedBooks is not an array:', recommendedBooks);
      return [];
    }
    if (!Array.isArray(performance)) {
      console.error('❌ performance is not an array:', performance);
      performance = [];
    }
    if (!Array.isArray(library)) {
      console.error('❌ library is not an array:', library);
      lib = [];
    }

    // -------------------------------------------------------------------
    // Helper: get read info
    // -------------------------------------------------------------------
    const getReadInfo = (book) =>
      performance.find((entry) => entry.book.bookId === book.id);

    // -------------------------------------------------------------------
    // Helper: sort by reading history
    // -------------------------------------------------------------------
    const sortByReadHistory = (books) => {
      return books.sort((a, b) => {
        const aRead = getReadInfo(a);
        const bRead = getReadInfo(b);

        if (!aRead && bRead) return -1;
        if (aRead && !bRead) return 1;
        if (!aRead && !bRead) return 0;

        return (
          new Date(aRead.dateRead.toDate()) - new Date(bRead.dateRead.toDate())
        );
      });
    };

    // -------------------------------------------------------------------
    // STEP 1: Sort recommendedBooks by wordLength
    // -------------------------------------------------------------------
    const sorted = [...recommendedBooks].sort(
      (a, b) => a.wordLength - b.wordLength,
    );

    if (sorted.length === 0) return [];

    const lengths = sorted.map((b) => b.wordLength);
    const min = lengths[0];
    const max = lengths[lengths.length - 1];
    const mean = lengths.reduce((a, b) => a + b, 0) / lengths.length;

    const stdDev = Math.sqrt(
      lengths.reduce((acc, x) => acc + Math.pow(x - mean, 2), 0) /
        lengths.length,
    );

    const distributionIndex = stdDev / mean;

    // -------------------------------------------------------------------
    // STEP 2: Decide between 3 or 4 buckets
    // -------------------------------------------------------------------
    const numBuckets = distributionIndex > 0.35 ? 4 : 3;

    // -------------------------------------------------------------------
    // STEP 3: Slice the sorted array into equal-sized buckets
    // -------------------------------------------------------------------
    const bucketSize = Math.floor(sorted.length / numBuckets);
    let buckets = [];

    for (let i = 0; i < numBuckets; i++) {
      const start = i * bucketSize;
      const end = i === numBuckets - 1 ? sorted.length : (i + 1) * bucketSize;
      buckets.push(sorted.slice(start, end));
    }

    // -------------------------------------------------------------------
    // STEP 4: Ensure minimum bucket size using borrowing / library
    // -------------------------------------------------------------------

    // Set of used book IDs so library doesn’t produce duplicates
    const usedIds = new Set(sorted.map((b) => b.id));

    const availableLibrary = library.filter((b) => !usedIds.has(b.id));
    const sortedLibrary = sortByReadHistory(availableLibrary);

    for (let i = 0; i < buckets.length; i++) {
      if (buckets[i].length >= MIN_BUCKET_SIZE) continue;

      let deficit = MIN_BUCKET_SIZE - buckets[i].length;

      // ---- Borrow from NEXT bucket (longer books) ----
      if (i + 1 < buckets.length && buckets[i + 1].length > MIN_BUCKET_SIZE) {
        buckets[i + 1].sort((a, b) => b.wordLength - a.wordLength); // longest first
        const toBorrow = buckets[i + 1].splice(0, deficit);
        buckets[i].push(...toBorrow);
        continue;
      }

      // ---- Borrow from PREVIOUS bucket (shorter books) ----
      if (i - 1 >= 0 && buckets[i - 1].length > MIN_BUCKET_SIZE) {
        buckets[i - 1].sort((a, b) => a.wordLength - b.wordLength); // shortest first
        const toBorrow = buckets[i - 1].splice(0, deficit);
        buckets[i].push(...toBorrow);
        continue;
      }
    }

    // -------------------------------------------------------------------
    // STEP 5: Sort buckets by reading history for final output
    // -------------------------------------------------------------------
    buckets = buckets.map((bucket) => sortByReadHistory(bucket));

    return buckets;
  };

  useEffect(() => {
    if (!readerId) {
      return;
    }
    getDocument('demoReaders', readerId).then((resGetProfile) => {
      if (!resGetProfile.success) {
        toast.error("Couldn't get the reader profile");
        return;
      }
      setReaderProfile(resGetProfile.data);
    });
  }, [readerId]);

  useEffect(() => {
    if (!readerProfile) return;
    const todaysDate = new Date();
    const DDMMYYYY =
      todaysDate.getDate() +
      '-' +
      todaysDate.getMonth() +
      1 +
      '-' +
      todaysDate.getFullYear();

    if (
      readerProfile &&
      readerProfile.readerQuests &&
      readerProfile.readerQuests.entries &&
      readerProfile.readerQuests.entries[DDMMYYYY]
    ) {
      if (readerProfile.readerQuests.entries[DDMMYYYY].state === 'done') {
        toast.warn('You are all set for today. Taking you back!');

        setTimeout(() => {
          window.location.replace('/');
        }, 5000);
      }
      setState(readerProfile.readerQuests.entries[DDMMYYYY].state);
      setStreaks(readerProfile.readerQuests.data.streaks || 0);
      setMaxStreaks(readerProfile.readerQuests.data.maxStreaks || 0);
      return;
    }
    setState('init');

    const matchinLexileBooks = getBooksMatchingLexile(
      getLexile(readerProfile.performance),
    );

    const booksToAvoid = booksToAvoidFromThePast100Days(
      readerProfile.performance,
    );
    const target = getTarget(
      readerProfile.performance,
      readerProfile.target || 500,
    );
    setWordTarget(target);
    //Continue from here.
    // At stage 3.5, the reader should be able to adjust the target
    // problem: if setWordTarget is updated here, useState will continuously call itself
    // if it is not updated here, we don't know how to set the wordTarget
    // possible solution: seperate this function into 2 and pick the books, every time wordTarget is updated.

    const orientation = getOrientation(readerProfile.performance);
    const popularGenres = getPopularGenres(readerProfile.performance);

    let recommendedBooks = matchinLexileBooks.filter(
      (book) =>
        (!orientation || book.orientation === orientation) &&
        popularGenres.some((genre) => book.tags.includes(genre)) &&
        !booksToAvoid.has(book.id) &&
        book.wordLength <= target / 2 + target / 6 &&
        book.wordLength >= target / 6,
    );

    if (recommendedBooks.length < 15) {
      recommendedBooks = matchinLexileBooks.filter(
        (book) =>
          popularGenres.some((genre) => book.tags.includes(genre)) &&
          !booksToAvoid.has(book.id) &&
          book.wordLength <= target / 2 + target / 6 &&
          book.wordLength >= target / 6,
      );
    }

    if (recommendedBooks.length < 15) {
      recommendedBooks = matchinLexileBooks.filter(
        (book) =>
          !booksToAvoid.has(book.id) &&
          book.wordLength <= target / 2 + target / 6 &&
          book.wordLength >= target / 6,
      );
    }

    if (recommendedBooks.length < 15) {
      recommendedBooks = matchinLexileBooks.filter(
        (book) => !booksToAvoid.has(book.id),
      );
    }

    const buckets = giveBucketsByDistribution(
      recommendedBooks,
      readerProfile.performance,
      library,
    );
    setBuckets(buckets);
  }, [readerProfile]);

  const handleSelectBook = (book, index) => {
    let tempBooks = [...selectedBooks];
    tempBooks[index] = book;
    setSelectedBooks(tempBooks);
  };

  useEffect(() => {
    if (selectedBooks.length === 0) return;
    setTimeout(() => {
      if (selectedBooks.length === 1) {
        setMessageIndex(toggleSkip ? 6 : 5);
      } else if (selectedBooks.length === 2) {
        setMessageIndex(toggleSkip ? 8 : 7);
      } else if (selectedBooks.length === 3) {
        if (buckets.length === 4) {
          setMessageIndex(toggleSkip ? 10 : 9);
        } else {
          setMessageIndex(11);
        }
      } else if (selectedBooks.length === 4) {
        setMessageIndex(toggleSkip ? 12 : 12);
      }
    }, 500);
  }, [selectedBooks]);

  const handleSubmit = () => {
    // Submit selected books logic here

    getDocument('demoReaders', readerId).then((resGetProfile) => {
      if (!resGetProfile.success) {
        toast.error("Couldn't get the files");
        return;
      }
      let recentReaderProfile = resGetProfile.data;

      const todaysDate = new Date();
      const DDMMYYYY =
        todaysDate.getDate() +
        '-' +
        todaysDate.getMonth() +
        1 +
        '-' +
        todaysDate.getFullYear();

      let readerQuests = recentReaderProfile?.readerQuests || {
        data: {
          streaks: 0,
          maxStreaks: 0,
          questsComplete: 0,
        },
        entries: {},
      };
      if (readerQuests.entries[DDMMYYYY]) {
        toast.warn('You already finished the quest');
        setState(readerQuests.entries[DDMMYYYY].state);
        return;
      }
      readerQuests.entries[DDMMYYYY] = {
        selectedBooks: selectedBooks,
        state: 'read',
      };
      recentReaderProfile.readerQuests = readerQuests;
      updateDocument(
        'demoReaders',
        recentReaderProfile.id,
        recentReaderProfile,
        auth.currentUser,
      ).then((resUpdate) => {
        if (!resUpdate.success) {
          toast.error(resUpdate.message);
          return;
        }
        setState(recentReaderProfile.readerQuests.entries[DDMMYYYY].state);
        setReaderProfile(recentReaderProfile);
      });
    });
  };

  return (
    <div
      className={
        state === 'read' || state === 'quiz'
          ? 'reading-quest-container reading-quest-container-read'
          : 'reading-quest-container'
      }>
      {state === 'init' && (
        <>
          <h2>Reading Quest Room{messageIndex}</h2>

          {!toggleSkip && (
            <button
              className='skip-conversation-button'
              onClick={() => {
                setSkip(true);
                setMessageIndex(4);
              }}>
              Skip
            </button>
          )}

          {messageIndex === 4 && buckets.length > 0 && (
            <>
              <BookShelf
                bucket={buckets[0].slice(0, 5)}
                bucketIndex={1}
                onSelectBook={handleSelectBook}
                setMessageIndex={setMessageIndex}
              />
            </>
          )}
          {messageIndex === 6 && buckets.length > 0 && (
            <>
              <BookShelf
                bucket={buckets[1].slice(-5)}
                bucketIndex={2}
                onSelectBook={handleSelectBook}
                setMessageIndex={setMessageIndex}
              />
            </>
          )}

          {messageIndex === 8 && buckets.length > 0 && (
            <>
              <BookShelf
                bucket={buckets[2].slice(-5)}
                bucketIndex={3}
                onSelectBook={handleSelectBook}
                setMessageIndex={setMessageIndex}
              />
            </>
          )}

          {messageIndex === 10 && buckets.length > 0 && (
            <>
              <BookShelf
                bucket={buckets[3].slice(-5)}
                bucketIndex={4}
                onSelectBook={handleSelectBook}
                setMessageIndex={setMessageIndex}
              />
            </>
          )}

          {messageIndex >= 4 && (
            <SelectedBooks
              selectedBooks={selectedBooks}
              length={buckets.length}
            />
          )}

          <GreetingWarden
            messageIndex={messageIndex}
            setMessageIndex={setMessageIndex}
            handleSubmit={handleSubmit}
          />
        </>
      )}

      {(state == 'read' || state == 'quiz') && (
        <QuestReadingRoom
          readerProfile={readerProfile}
          bookList={bookList}
          setBookList={setBookList}
          state={state}
          setState={setState}
          streaks={streaks}
          setStreaks={setStreaks}
          maxStreaks={maxStreaks}
          setMaxStreaks={setMaxStreaks}
        />
      )}

      <img
        src='https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FCursed_Tome_Super_Deco.png?alt=media&token=62d6176a-9d0c-4b71-aafb-86049828cd34'
        alt='Coc Cursed stone'
        className='cursed-stone-img'
      />

      {state === 'done' && (
        <div>
          <h2>Done for today</h2>
          <img
            src='https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fgrand%20warden%2FAnime_GrandWarden_1.png?alt=media&token=e7203829-aa0d-4cd3-9485-600478c72a1e'
            alt=''
            style={{
              margin: 'auto',
            }}
          />
        </div>
      )}
    </div>
  );
};
